import * as React from 'react';
import { combineReducers } from 'redux';
import { router5Reducer } from 'redux-router5';

import * as shared from './shared';
import * as admin from './admin';
import * as sender from './sender';
import * as support from './support';
import * as receiver from './receiver';
import * as pos from './pos';

const enabledApps = [
  admin,
  sender,
  support,
  receiver,
  pos,
  // shared app should be the last because it has a catch-all endpoint
  shared,
];

export const initReducers = () => {
  let reducers = {
    router: router5Reducer,
  };

  for (let app of enabledApps) {
    reducers = {...reducers, ...app.initReducers()};
  }

  return combineReducers(reducers);
};

export const initRoutes = () => {
  let routes = [];

  for (let app of enabledApps) {
    routes = [...routes, ...app.initRoutes()];
  }

  return routes;
};

export const initApp = (store) => {
  for (let app of enabledApps) {
    app.initApp(store);
  }
};
